export function shouldLoadChildTagsOnChevronExpand(
  isOpen: boolean,
  nodeId: string,
  childrenLoaded: Record<string, boolean>
): boolean {
  return isOpen && !childrenLoaded[nodeId];
}
